import axios from 'axios'
import store from '@/store'
import { app } from '@/main.js'

// for multiple requests
let isRefreshing = false;
let failedQueue = [];

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/'

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  })

  failedQueue = [];
}

// Request interceptor for API calls
axios.interceptors.request.use(
  async config => {
    const token = store.state.auth.accessToken
    config.headers = {
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    return config;
  },
  error => {
    Promise.reject(error)
});

axios.interceptors.response.use(function (response) {
  return response;
}, async function (error) {

  const originalRequest = error.config;

  if (error.response.status === 401 && !originalRequest._retry) {

    if (isRefreshing) {
      return new Promise(function(resolve, reject) {
        failedQueue.push({resolve, reject})
      }).then(token => {
        originalRequest.headers['Authorization'] = 'Bearer ' + token;
        return axios(originalRequest);
      }).catch(err => {
        return Promise.reject(err);
      })
    }

    originalRequest._retry = true;
    isRefreshing = true;


    let data = {
      id: store.state.auth.jwtPayload.user_id,
      access_token: store.state.auth.accessToken,
      refresh_token: store.state.auth.jwtPayload.jwt_refresh_token
    }

    return new Promise(function (resolve, reject) {
      axios.post('/users/token/refresh', data)
        .then(({data}) => {
          store.commit("auth/setAccessToken", data.user.access_token);
          store.commit("auth/setJwtPayload", app.helpers.parseJwt(data.user.access_token));
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.user.access_token;
          originalRequest.headers['Authorization'] = 'Bearer ' + data.user.access_token;
          processQueue(null, data.user.access_token);
          resolve(axios(originalRequest));
        })
        .catch((err) => {
          processQueue(err, null);

          reject(err);
          store.commit('auth/setTokenExpires');
          store.dispatch('auth/logout');
        })
        .finally(() => { isRefreshing = false })
    })
  }

  return Promise.reject(error);
});

export default {
  install: (app) => {
    app.config.globalProperties.$axios = axios
  }
}